exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".link-4a857430{font-weight:500;font-size:14px}.milestone-c0a089a2{position:relative;display:flex;width:240px;margin-bottom:15px}.milestone-c0a089a2:last-child{margin-bottom:0px}.milestone-c0a089a2 img{height:60px;width:60px;margin-right:10px}.milestone-c0a089a2 .locked-c50a024f{position:absolute;left:0px;top:0px}.milestone-c0a089a2 .info-6179a3a7{display:flex;flex-direction:column;width:170px}.milestone-c0a089a2 .title-8eb0e5f3,.milestone-c0a089a2 .subInfo-ebb216d6{line-height:20px}.milestone-c0a089a2 .subInfo-ebb216d6{font-size:13px;color:#757575}\n", ""]);

// Exports
exports.locals = {
	"link": "link-4a857430",
	"milestone": "milestone-c0a089a2",
	"locked": "locked-c50a024f",
	"info": "info-6179a3a7",
	"title": "title-8eb0e5f3",
	"subInfo": "subInfo-ebb216d6"
};